import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "className", "id", "value", "isDisabled", "hasError", "onChange", "isRequired", "data", "onBlur"];
import React, { useMemo } from 'react';
import { Label, Icon, Element } from '../';
import getConfig from '../../js/settings';
import { appendHtmlClass } from '../../js/util';
import withValidation from '../Form/validation';
import '../Checkbox/_index.scss';
import './_index.scss';
var RadioMemo = /*#__PURE__*/React.memo(function Radio(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    value = _ref.value,
    isDisabled = _ref.isDisabled,
    hasError = _ref.hasError,
    onChange = _ref.onChange,
    isRequired = _ref.isRequired,
    data = _ref.data,
    onBlur = _ref.onBlur,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var CHECKBOX_ICON_SIZE = getConfig('CHECKBOX_ICON_SIZE');
  var onClick = function onClick(e) {
    e.preventDefault();
    if (typeof onChange === 'function' && !isDisabled) onChange(data, e);
  };
  className = appendHtmlClass(className, 'radio');
  if (value === data) className = appendHtmlClass(className, 'checked');
  var disabled = isDisabled ? {
    disabled: 'disabled'
  } : {};
  var isChecked = value === data;
  var inputValue = useMemo(function () {
    if (typeof data === 'string') return data;else if (typeof data === 'object' && data.hasOwnProperty('id')) {
      if (typeof data.id === 'string') return data.id;else return data.id.toString();
    }
    return data.toString();
  }, [data]);
  return /*#__PURE__*/React.createElement(Label, {
    hasError: hasError,
    isDisabled: isDisabled,
    className: className,
    htmlFor: id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    type: "radio",
    id: id,
    required: isRequired,
    value: isChecked ? inputValue : '',
    checked: isChecked,
    readOnly: true
  }, disabled, rest)), /*#__PURE__*/React.createElement(Icon, {
    className: "icon-check",
    name: "circle",
    display: "block",
    size: CHECKBOX_ICON_SIZE
  }), children && /*#__PURE__*/React.createElement(Element, {
    as: "div",
    className: "label-text"
  }, children));
});
RadioMemo.defaultProps = {
  data: true,
  value: false,
  isDisabled: false,
  hasError: false,
  isRequired: false
};
export default withValidation(RadioMemo);
export { RadioMemo as Radio };